import { MonitoringErrorDetails } from "../../../domain/monitoring/monitoringErrorDetails";
import moment from "moment";
import { IMonitoringErrorsRepository } from "../../../domain/monitoring/i-monitoring-errors-repository";

export class MonitoringAlertsViewModel {
  public errors: MonitoringErrorViewModel[] = [];
  private _refreshInterval;
  constructor(
    private _monitoringErrorsRepository: IMonitoringErrorsRepository,
  ) {}

  async onInit() {
    await this.playAudio(true);
    this.errors = await this._getErrors();

    this._refreshInterval = setInterval(async () => {
      await this.refreshAlertsState();
    }, 5 * 1000);
  }
  onDestroy(): void {
    clearInterval(this._refreshInterval);
  }
  async refreshAlertsState() {
    const updatedErrorsList = await this._getErrors();
    if (
      MonitoringAlertsViewModel._checkIfAnyUpdates(
        this.errors,
        updatedErrorsList,
      )
    ) {
      await this.playAudio();
    }
    this.errors = updatedErrorsList;
  }

  formatTime(time: moment.Moment) {
    return time.format("DD/MM/YYYY HH:mm:ss.SSS");
  }

  async playAudio(onlyLoad = false) {
    const audio = new Audio();
    audio.src = "./assets/BikeHorn.wav";
    audio.load();
    if (!onlyLoad) {
      await audio.play();
    }
  }
  public test() {
    this.errors[0].isNew = true;

    this.playAudio().then();
  }
  private _getErrors(): Promise<MonitoringErrorViewModel[]> {
    return this._monitoringErrorsRepository
      .get(null, null, null, null, null, true)
      .then((result) => {
        return result
          .map((r) => new MonitoringErrorViewModel(r))
          .sort((a, b) => b.createdTime.diff(a.createdTime));
      });
  }

  private static _checkIfAnyUpdates(
    oldList: MonitoringErrorViewModel[],
    newList: MonitoringErrorViewModel[],
  ): boolean {
    let result = false;
    if (newList.length > oldList.length) {
      result = true;
    } else {
      const oldListErrorIds = oldList.map((e) => e.id);
      for (let i = 0; i < newList.length; i++) {
        const newListError = newList[i];
        if (oldListErrorIds.includes(newListError.id) === false) {
          result = true;
          newListError.isNew = true;
        }
      }
    }
    return result;
  }
}

class MonitoringErrorViewModel extends MonitoringErrorDetails {
  constructor(
    error: MonitoringErrorDetails,
    public isNew = false,
  ) {
    super(
      error.id,
      error.errorId,
      error.platformId,
      error.platformName,
      error.channelId,
      error.channelName,
      error.availabilityZoneId,
      error.availabilityZoneName,
      error.count,
      error.severity,
      error.msg,
      error.createdTime,
      error.resolvedTime,
    );
  }
}
